import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "./Reveal";

export default function HowWeWork() {
  const { t } = useLang();

  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32"
      style={{ background: "var(--sap-gray-50)" }}
    >
      <div className="sap-container">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <Reveal className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="sap-divider-gold" />
              <span className="sap-overline">{t.process.overline}</span>
            </div>
            <h2
              className="font-serif leading-[1.1] tracking-tight"
              style={{
                fontSize: "clamp(1.9rem, 3.6vw, 3.2rem)",
                color: "var(--sap-navy)",
                fontWeight: 400,
              }}
            >
              {t.process.title}
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={120}>
            <p className="text-base md:text-lg leading-relaxed text-neutral-600">
              {t.process.subtitle}
            </p>
          </Reveal>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* horizontal line desktop */}
          <div
            className="hidden lg:block absolute top-8 left-8 right-8 h-px"
            style={{ background: "#d5b988" }}
            aria-hidden
          />
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-6">
            {t.process.steps.map((s, i) => (
              <Reveal key={i} delay={i * 100}>
                <div data-testid={`process-step-${i}`} className="relative">
                  <div className="flex lg:justify-start items-center gap-4 mb-6">
                    <div
                      className="relative z-10 flex items-center justify-center w-16 h-16 bg-white"
                      style={{ border: "1px solid var(--sap-gold)" }}
                    >
                      <span
                        className="font-serif text-xl"
                        style={{ color: "var(--sap-navy)" }}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                  </div>
                  <h3
                    className="font-serif text-xl md:text-2xl mb-2"
                    style={{ color: "var(--sap-navy)", fontWeight: 500 }}
                  >
                    {s.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-neutral-600 pr-4">
                    {s.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
